var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgManagerSchedule = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.8571 3.23828H5.52381C3.57766 3.23828 2 4.81594 2 6.76209V18.1907C2 20.1368 3.57766 21.7145 5.52381 21.7145H18.8571C20.8033 21.7145 22.381 20.1368 22.381 18.1907V6.76209C22.381 4.81594 20.8033 3.23828 18.8571 3.23828ZM5.52381 4.57161H18.8571C20.0669 4.57161 21.0476 5.55232 21.0476 6.76209V18.1907C21.0476 19.4004 20.0669 20.3811 18.8571 20.3811H5.52381C4.31404 20.3811 3.33333 19.4004 3.33333 18.1907V6.76209C3.33333 5.55232 4.31404 4.57161 5.52381 4.57161Z",
  fill: "#717171"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.0476 8V9.33333H3V8H22.0476Z",
  fill: "#717171"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.04769 2V6.7619H7.71436V2H9.04769Z",
  fill: "#717171"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.6666 2V6.7619H15.3333V2H16.6666Z",
  fill: "#717171"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgManagerSchedule);
export default ForwardRef;